import styled from 'styled-components';

const Container = styled.div`
  color: ${props => props.theme.colors.textPrimary};
  position: relative;
`;

export default Container;
